export const profileServiceData = [
	{
		id: 1,
		image: '/assets/images/myprofileInfo/profile1.png',
	},
	{
		id: 2,
		image: '/assets/images/myprofileInfo/profile2.png',
	},
	{
		id: 3,
		image: '/assets/images/myprofileInfo/profile3.png',
	},
	{
		id: 4,
		image: '/assets/images/myprofileInfo/profile4.png',
	},
	{
		id: 5,
		image: '/assets/images/myprofileInfo/profile5.png',
	},
	{
		id: 6,
		image: '/assets/images/myprofileInfo/profile6.png',
	},
];
